import { Container } from "../../../../components/Container";
import classNames from "classnames/dedupe";
import Autotrans from "../../../../assets/img/partners/autotransLogo.svg";
import Yavir from "../../../../assets/img/partners/yavirLogo.svg";
import EPilot from "../../../../assets/img/partners/epilotLogo.svg";
import Konsort from "../../../../assets/img/partners/konsortLogo.svg";
import TorgService from "../../../../assets/img/partners/torgservisLogo.svg";
import K from "../../../../assets/img/partners/kLogo.svg";
import Ende from "../../../../assets/img/partners/endevourLogo.svg";
import Fibra from "../../../../assets/img/partners/fiber.svg";
import PalitraMix from "../../../../assets/img/partners/palitraMix.svg";
import Digicode from "../../../../assets/img/partners/digicodeLogo.svg";
import styles from "./Participants.module.sass";

export const Participants = () => {
  const partnersList = [
    { img: Digicode },
    { img: Autotrans },
    { img: Yavir },
    { img: EPilot },
    { img: Konsort },
    { img: TorgService },
    { img: K },
    { img: Ende },
    { img: Fibra },
    { img: PalitraMix },
  ];

  const getPartner = (img: string) => (
    <div key={img} className={classNames("df-center", styles.img)}>
      <img className="img" src={img} alt="img: Partner" />
    </div>
  );

  return (
    <Container
      className={classNames("df-center fd-column", styles.container)}
      id="participants"
    >
      <div className={classNames("df-start fd-column", styles.content)}>
        <div className={classNames("df-start fd-column", styles.section)}>
          <p className={classNames(styles.subtitle, styles.textLeft)}>
            Учасники ПАБу
          </p>
          <div className={styles.wrapper}>
            {partnersList.map((item) => getPartner(item.img))}
          </div>
        </div>
      </div>
    </Container>
  );
};
